import butterChicken from "../../assets/images/butter-chicken.jpg";
import biryani from "../../assets/images/biryani.jpg";
import tandooriPlatter from "../../assets/images/tandoori-platter.jpg";
import thali from "../../assets/images/thali.jpg";
import diningArea from "../../assets/images/dining-area.jpg";
import tandoorKitchen from "../../assets/images/tandoor-kitchen.jpg";
import restaurantInterior from "../../assets/images/indian-restaurant-interior.jpg";

const galleryData = {
  
  heading: "Food & Restaurant Gallery",

  images: [
    { img: butterChicken, alt: "Butter Chicken" },
    { img: biryani, alt: "Hyderabadi Biryani" },
    { img: tandooriPlatter, alt: "Tandoori Platter" },
    { img: thali, alt: "Indian Thali" },
    { img: diningArea, alt: "Dining Area" },
    { img: tandoorKitchen, alt: "Tandoor Kitchen" },
    { img: butterChicken, alt: "Butter Chicken Special" },
    { img: biryani, alt: "Biryani Special" },
    { img: restaurantInterior, alt: "Restaurant Interior" },
  ],
};

export default galleryData;